<div class="row g-3">
  @for (result of results; track result; let last = $last) {
    @switch (result.group) {
      @case (Group.MULTIMEDIA) {
        <app-search-result-video
          class="col-xl-3 col-md-4"
          [result]="result"></app-search-result-video>
      }
      @case (Group.TRAINING) {
        <div class="col-xl-3 col-md-4">
          @switch (result.entityType) {
            @case (EntityType.PATH) {
              <app-search-result-path
                [result]="result"></app-search-result-path>
            }
            @case (EntityType.PATH_CHAPTER) {
              <app-search-result-chapter
                [result]="result"></app-search-result-chapter>
            }
            @case (EntityType.EXERCISE) {
              <app-search-result-exercise
                [result]="result"></app-search-result-exercise>
            }
            @case (EntityType.GUIDE) {
              <app-search-result-workbook
                [result]="result"></app-search-result-workbook>
            }
            @case (EntityType.LESSON) {
              <app-search-result-video
                class="col-xl-3 col-md-4"
                [result]="result"></app-search-result-video>
            }
          }
        </div>
      }
      @case (Group.SOFTWARE) {
        <div
          class="col-xl-4 col-md-6"
        >
          @switch (result.source) {
            @case (Source.DOWNLOAD_META) {
              <app-search-result-download-meta
                [result]="result"/>
            }
            @case (Source.MARKETPLACE_ENTRY) {
              <app-search-result-marketplace-entry
                [result]="result"/>
            }
          }
        </div>
      }
      @default {
        <div
          class="col-12">
          @switch (result.source) {
            @case (Source.DOC) {
              <app-search-result-doc
                [result]="result"></app-search-result-doc>
            }
            @default {
              <app-search-result-generic
                [result]="result"
                [crumbs]="[result.source | source]"></app-search-result-generic>
            }
          }
        </div>
      }
    }
  }
</div>
